import { openModal } from '@core/components/ModalStack';
import { CustomDatePickerModalProps } from './CustomDatePickerModal';

export async function openCustomDatePickerModal(props: CustomDatePickerModalProps) {
  const { CustomDatePickerModal } = await import('./CustomDatePickerModal');

  openModal(CustomDatePickerModal, props);
}
